import req from 'utils/req';

const PAGE_SIZE = 50;

export const fetchFavoritesWithExperience = async (currency: string) => {
  const searchParams = new URLSearchParams({
    include: 'experience',
    per_page: PAGE_SIZE.toString(),
    currency,
  });

  const response = await req(
    `${URL_API_HOST}/api/v3/experiences/favorites?${searchParams.toString()}`,
  ).get();

  return response;
};

export function toggleFavorite(
  id: string,
  isWished: boolean,
): Promise<boolean> {
  if (isWished) {
    return req(`${URL_API_HOST}/api/v3/experiences/favorites`).post({
      experienceId: id,
    });
  }
  return req(`${URL_API_HOST}/api/v3/experiences/favorites/${id}`).delete();
}
